import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FaIcons from 'react-icons/fa';

const { FaYoutube } = FaIcons;

function VideoSection() {
  const videos = [
    {
      id: 1,
      url: "https://www.youtube.com/watch?v=3zf9UxKFhSg",
      title: "Video 1"
    },
    {
      id: 2,
      url: "https://www.youtube.com/watch?v=zhvVms46T4w&t=3s",
      title: "Video 2"
    },
    {
      id: 3,
      url: "https://www.youtube.com/watch?v=zgnTqg_v_is",
      title: "Video 3"
    },
    {
      id: 4,
      url: "https://www.youtube.com/watch?v=YWns3VAaYgA&list=PLPQKRklxYFFjHe2RO3e8y60Hhjl1G7SlD&index=4",
      title: "Video 4"
    },
    {
      id: 5,
      url: "https://www.youtube.com/watch?v=5o_dwALHsXI",
      title: "Video 5"
    },
    {
      id: 6,
      url: "https://www.youtube.com/watch?v=hC6vS8yC-fk",
      title: "Video 6"
    }
  ];

  return (
    <div className="mt-8 mb-8 p-8 bg-white rounded-3xl shadow-xl border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-red-500 to-pink-500 p-3 rounded-2xl mr-4 shadow-lg">
          <SafeIcon icon={FaYoutube} className="text-white text-4xl" />
        </div>
        <h2 className="text-3xl font-bold bg-gradient-to-r from-red-500 to-pink-500 bg-clip-text text-transparent">
          Video da guardare ogni giorno
        </h2>
      </div>
      
      <p className="text-gray-600 mb-6 text-lg">
        Premi sui pulsanti qui sotto per guardare i video motivazionali su YouTube.
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {videos.map(video => (
          <a
            key={video.id}
            href={video.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center p-4 bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          >
            {video.title}
          </a>
        ))}
      </div>
    </div>
  );
}

export default VideoSection;